import React from "react";
import "./datenSchutz.scss";

function DatenSchutz() {
  return (
    <div className="datenSchutz_container">
      <div className="datenSchutz">
        <h1>Datenschutzerklaerung</h1>

        <article className="policySection">
          <h2>1. Datenschutz auf einen Blick</h2>
          <p className="policyParagraph"><strong>Allgemeine Hinweise</strong> Die folgenden Hinweise geben einen einfachen
            Überblick darüber, was mit Ihren personenbezogenen Daten passiert,
            wenn Sie diese Website besuchen. Personenbezogene Daten sind alle
            Daten, mit denen Sie persönlich identifiziert werden können.
            Ausführliche Informationen zum Thema Datenschutz entnehmen Sie
            unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </p>
          <p className="policyParagraph"><strong>Datenerfassung auf dieser Website</strong> Wer ist verantwortlich für die
            Datenerfassung auf dieser Website? Die Datenverarbeitung auf dieser
            Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten
            können Sie dem Abschnitt „Hinweis zur Verantwortlichen Stelle“ in
            dieser Datenschutzerklärung entnehmen.
          </p>
          <p className="policyParagraph"><strong>Wie erfassen wir Ihre Daten?</strong> Ihre Daten werden zum einen dadurch
            erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.
          </p>
          <p className="policyParagraph">
            B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere
            Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch
            der Website durch unsere IT-Systeme erfasst. Das sind vor allem
            technische Daten (z.
          </p>
          <p className="policyParagraph">
            B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
            Die Erfassung dieser Daten erfolgt automatisch, sobald Sie diese
            Website betreten.
          </p>
          <p className="policyParagraph"><strong>Wofür nutzen wir Ihre Daten?</strong> Ein Teil der Daten wird erhoben, um
            eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere
            Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.
          </p>
          <p className="policyParagraph">
            Sofern über die Website Verträge geschlossen oder angebahnt werden
            können, werden die übermittelten Daten auch für Vertragsangebote,
            Bestellungen oder sonstige Auftragsanfragen verarbeitet. Welche
            Rechte haben Sie bezüglich Ihrer Daten? Sie haben jederzeit das
            Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck
            Ihrer gespeicherten personenbezogenen Daten zu erhalten.
          </p>
          <p className="policyParagraph">
            Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser
            Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung
            erteilt haben, können Sie diese Einwilligung jederzeit für die
            Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten
            Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen
            Daten zu verlangen.
          </p>
          <p className="policyParagraph">
            Des Weiteren steht Ihnen ein Beschwerderecht bei der zuständigen
            Aufsichtsbehörde zu. Hierzu sowie zu weiteren Fragen zum Thema
            Datenschutz können Sie sich jederzeit an uns wenden. Analyse-Tools
            und Tools von Dritt­anbietern Beim Besuch dieser Website kann Ihr
            Surf-Verhalten statistisch ausgewertet werden.
          </p>
          <p className="policyParagraph">
            Das geschieht vor allem mit sogenannten Analyseprogrammen.
            Detaillierte Informationen zu diesen Analyseprogrammen finden Sie in
            der folgenden Datenschutzerklärung.
          </p>
        </article>

        <article className="policySection">
          <h2>2. Hosting</h2>
          <p className="policyParagraph">
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
            Externes Hosting Diese Website wird extern gehostet. Die
            personenbezogenen Daten, die auf dieser Website erfasst werden,
            werden auf den Servern des Hosters / der Hoster gespeichert. Hierbei
            kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und
            Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen,
            Websitezugriffe und sonstige Daten, die über eine Website generiert
            werden, handeln.
          </p>
          <p className="policyParagraph">
            Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung
            gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1
            lit. b DSGVO) und im Interesse einer sicheren, schnellen und
            effizienten Bereitstellung unseres Online-Angebots durch einen
            professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO). Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Unser(e) Hoster wird bzw. werden Ihre
            Daten nur insoweit verarbeiten, wie dies zur Erfüllung seiner
            Leistungspflichten erforderlich ist und unsere Weisungen in Bezug
            auf diese Daten befolgen.
          </p>
          <p className="policyParagraph">
            Wir setzen folgende(n) Hoster ein: Siteground{" "}
            <a
              href="https://de.siteground.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://de.siteground.com/
            </a>
          </p>
        </article>

        <article className="policySection">
          <h2>3. Allgemeine Hinweise und Pflicht­informationen</h2>
          <p className="policyParagraph"><strong>Datenschutz</strong> Die Betreiber dieser Seiten nehmen den Schutz Ihrer
            persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen
            Daten vertraulich und entsprechend den gesetzlichen
            Datenschutzvorschriften sowie dieser Datenschutzerklärung. Wenn Sie
            diese Website benutzen, werden verschiedene personenbezogene Daten
            erhoben.
          </p>
          <p className="policyParagraph">
            Personenbezogene Daten sind Daten, mit denen Sie persönlich
            identifiziert werden können. Die vorliegende Datenschutzerklärung
            erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie
            erläutert auch, wie und zu welchem Zweck das geschieht.
          </p>
          <p className="policyParagraph">
            Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B.
            bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann.
            Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist
            nicht möglich.
          </p>
          <p className="policyParagraph"><strong>Hinweis zur verantwortlichen Stelle</strong> Die verantwortliche Stelle für
            die Datenverarbeitung auf dieser Website ist: GF Sami Jallous
            Zossener Chaussee 38 15838 Am Mellensee Telefon: 015114766666
            E-Mail: <a href="mailto:info@nassco-m.de">info@nassco-m.de</a>{" "}
            Verantwortliche Stelle ist die natürliche oder juristische Person,
            die allein oder gemeinsam mit anderen über die Zwecke und Mittel der
            Verarbeitung von personenbezogenen Daten (z. B. Namen,
            E-Mail-Adressen o.
          </p>
          <p className="policyParagraph">
            Ä.) entscheidet. Speicherdauer Soweit innerhalb dieser
            Datenschutzerklärung keine speziellere Speicherdauer genannt wurde,
            verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für
            die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes
            Löschersuchen geltend machen oder eine Einwilligung zur
            Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir
            keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer
            personenbezogenen Daten haben (z.
          </p>
          <p className="policyParagraph">
            B. steuer- oder handelsrechtliche Aufbewahrungsfristen); im
            letztgenannten Fall erfolgt die Löschung nach Fortfall dieser
            Gründe. Allgemeine Hinweise zu den Rechtsgrundlagen der
            Datenverarbeitung auf dieser Website Sofern Sie in die
            Datenverarbeitung eingewilligt haben, verarbeiten wir Ihre
            personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO
            bzw. Art. 9 Abs. 2 lit. a DSGVO, sofern besondere Datenkategorien
            nach Art. 9 Abs. 1 DSGVO verarbeitet werden.
          </p>
          <p className="policyParagraph">
            Im Falle einer ausdrücklichen Einwilligung in die Übertragung
            personenbezogener Daten in Drittstaaten erfolgt die
            Datenverarbeitung außerdem auf Grundlage von Art. 49 Abs. 1 lit. a
            DSGVO. Sofern Sie in die Speicherung von Cookies oder in den Zugriff
            auf Informationen in Ihr Endgerät (z. B. via Device-Fingerprinting)
            eingewilligt haben, erfolgt die Datenverarbeitung zusätzlich auf
            Grundlage von § 25 Abs. 1 TDDDG.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Sind Ihre Daten zur
            Vertragserfüllung oder zur Durchführung vorvertraglicher Maßnahmen
            erforderlich, verarbeiten wir Ihre Daten auf Grundlage des Art. 6
            Abs. 1 lit. b DSGVO. Des Weiteren verarbeiten wir Ihre Daten, sofern
            diese zur Erfüllung einer rechtlichen Verpflichtung erforderlich
            sind auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO.
          </p>
          <p className="policyParagraph">
            Die Datenverarbeitung kann ferner auf Grundlage unseres berechtigten
            Interesses nach Art. 6 Abs. 1 lit. f DSGVO erfolgen. Über die
            jeweils im Einzelfall einschlägigen Rechtsgrundlagen wird in den
            folgenden Absätzen dieser Datenschutzerklärung informiert. Hinweis
            zur Datenweitergabe in datenschutzrechtlich nicht sichere
            Drittstaaten sowie die Weitergabe an US-Unternehmen, die nicht
            DPF-zertifiziert sind Wir verwenden unter anderem Tools von
            Unternehmen mit Sitz in datenschutzrechtlich nicht sicheren
            Drittstaaten sowie US-Tools, deren Anbieter nicht nach dem
            EU-US-Data Privacy Framework (DPF) zertifiziert sind.
          </p>
          <p className="policyParagraph">
            Wenn diese Tools aktiv sind, können Ihre personenbezogene Daten in
            diese Staaten übertragen und dort verarbeitet werden. Wir weisen
            darauf hin, dass in datenschutzrechtlich unsicheren Drittstaaten
            kein mit der EU vergleichbares Datenschutzniveau garantiert werden
            kann. Wir weisen darauf hin, dass die USA als sicherer Drittstaat
            grundsätzlich ein mit der EU vergleichbares Datenschutzniveau
            aufweisen.
          </p>
          <p className="policyParagraph">
            Eine Datenübertragung in die USA ist danach zulässig, wenn der
            Empfänger eine Zertifizierung unter dem „EU-US Data Privacy
            Framework“ (DPF) besitzt oder über geeignete zusätzliche Garantien
            verfügt. Informationen zu Übermittlungen an Drittstaaten
            einschließlich der Datenempfänger finden Sie in dieser
            Datenschutzerklärung. Empfänger von personenbezogenen Daten Im
            Rahmen unserer Geschäftstätigkeit arbeiten wir mit verschiedenen
            externen Stellen zusammen.
          </p>
          <p className="policyParagraph">
            Dabei ist teilweise auch eine Übermittlung von personenbezogenen
            Daten an diese externen Stellen erforderlich. Wir geben
            personenbezogene Daten nur dann an externe Stellen weiter, wenn dies
            im Rahmen einer Vertragserfüllung erforderlich ist, wenn wir
            gesetzlich hierzu verpflichtet sind (z. B.
          </p>
          <p className="policyParagraph">
            Weitergabe von Daten an Steuerbehörden), wenn wir ein berechtigtes
            Interesse nach Art. 6 Abs. 1 lit. f DSGVO an der Weitergabe haben
            oder wenn eine sonstige Rechtsgrundlage die Datenweitergabe erlaubt.
            Beim Einsatz von Auftragsverarbeitern geben wir personenbezogene
            Daten unserer Kunden nur auf Grundlage eines gültigen Vertrags über
            Auftragsverarbeitung weiter. Im Falle einer gemeinsamen Verarbeitung
            wird ein Vertrag über gemeinsame Verarbeitung geschlossen.
          </p>
          <p className="policyParagraph"><strong>Widerruf Ihrer Einwilligung zur Datenverarbeitung</strong> Viele
            Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen
            Einwilligung möglich. Sie können eine bereits erteilte Einwilligung
            jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf
            erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>
          <p className="policyParagraph">
            <strong>Widerspruchsrecht gegen die Datenerhebung in besonderen Fällen sowie
            gegen Direktwerbung (Art. 21 DSGVO)</strong> WENN DIE DATENVERARBEITUNG AUF
            GRUNDLAGE VON ART. 6 ABS. 1 LIT. E ODER F DSGVO ERFOLGT, HABEN SIE
            JEDERZEIT DAS RECHT, AUS GRÜNDEN, DIE SICH AUS IHRER BESONDEREN
            SITUATION ERGEBEN, GEGEN DIE VERARBEITUNG IHRER PERSONENBEZOGENEN
            DATEN WIDERSPRUCH EINZULEGEN; DIES GILT AUCH FÜR EIN AUF DIESE
            BESTIMMUNGEN GESTÜTZTES PROFILING. DIE JEWEILIGE RECHTSGRUNDLAGE,
            AUF DENEN EINE VERARBEITUNG BERUHT, ENTNEHMEN SIE DIESER
            DATENSCHUTZERKLÄRUNG.
          </p>
          <p className="policyParagraph">
            WENN SIE WIDERSPRUCH EINLEGEN, WERDEN WIR IHRE BETROFFENEN
            PERSONENBEZOGENEN DATEN NICHT MEHR VERARBEITEN, ES SEI DENN, WIR
            KÖNNEN ZWINGENDE SCHUTZWÜRDIGE GRÜNDE FÜR DIE VERARBEITUNG
            NACHWEISEN, DIE IHRE INTERESSEN, RECHTE UND FREIHEITEN ÜBERWIEGEN
            ODER DIE VERARBEITUNG DIENT DER GELTENDMACHUNG, AUSÜBUNG ODER
            VERTEIDIGUNG VON RECHTSANSPRÜCHEN (WIDERSPRUCH NACH ART. 21 ABS. 1
            DSGVO). WERDEN IHRE PERSONENBEZOGENEN DATEN VERARBEITET, UM
            DIREKTWERBUNG ZU BETREIBEN, SO HABEN SIE DAS RECHT, JEDERZEIT
            WIDERSPRUCH GEGEN DIE VERARBEITUNG SIE BETREFFENDER
            PERSONENBEZOGENER DATEN ZUM ZWECKE DERARTIGER WERBUNG EINZULEGEN;
            DIES GILT AUCH FÜR DAS PROFILING, SOWEIT ES MIT SOLCHER
            DIREKTWERBUNG IN VERBINDUNG STEHT. WENN SIE WIDERSPRECHEN, WERDEN
            IHRE PERSONENBEZOGENEN DATEN ANSCHLIESSEND NICHT MEHR ZUM ZWECKE DER
            DIREKTWERBUNG VERWENDET (WIDERSPRUCH NACH ART. 21 ABS. 2 DSGVO).
          </p>
          <p className="policyParagraph"><strong>Beschwerde­recht bei der zuständigen Aufsichts­behörde</strong> Im Falle von
            Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht
            bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres
            gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des
            mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet
            anderweitiger verwaltungsrechtlicher oder gerichtlicher
            Rechtsbehelfe. Recht auf Daten­übertrag­barkeit Sie haben das Recht,
            Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung
            eines Vertrags automatisiert verarbeiten, an sich oder an einen
            Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu
            lassen.
          </p>
          <p className="policyParagraph">
            Sofern Sie die direkte Übertragung der Daten an einen anderen
            Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch
            machbar ist. Auskunft, Berichtigung und Löschung Sie haben im Rahmen
            der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf
            unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen
            Daten, deren Herkunft und Empfänger und den Zweck der
            Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung
            dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema
            personenbezogene Daten können Sie sich jederzeit an uns wenden.
          </p>
          <p className="policyParagraph"><strong>Recht auf Einschränkung der Verarbeitung</strong> Sie haben das Recht, die
            Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu
            verlangen. Hierzu können Sie sich jederzeit an uns wenden. Das Recht
            auf Einschränkung der Verarbeitung besteht in folgenden Fällen: Wenn
            Sie die Richtigkeit Ihrer bei uns gespeicherten personenbezogenen
            Daten bestreiten, benötigen wir in der Regel Zeit, um dies zu
            überprüfen.
          </p>
          <p className="policyParagraph">
            Für die Dauer der Prüfung haben Sie das Recht, die Einschränkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen. Wenn die
            Verarbeitung Ihrer personenbezogenen Daten unrechtmäßig
            geschah/geschieht, können Sie statt der Löschung die Einschränkung
            der Datenverarbeitung verlangen. Wenn wir Ihre personenbezogenen
            Daten nicht mehr benötigen, Sie sie jedoch zur Ausübung,
            Verteidigung oder Geltendmachung von Rechtsansprüchen benötigen,
            haben Sie das Recht, statt der Löschung die Einschränkung der
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </p>
          <p className="policyParagraph">
            Wenn Sie einen Widerspruch nach Art. 21 Abs. 1 DSGVO eingelegt
            haben, muss eine Abwägung zwischen Ihren und unseren Interessen
            vorgenommen werden. Solange noch nicht feststeht, wessen Interessen
            überwiegen, haben Sie das Recht, die Einschränkung der Verarbeitung
            Ihrer personenbezogenen Daten zu verlangen. Wenn Sie die
            Verarbeitung Ihrer personenbezogenen Daten eingeschränkt haben,
            dürfen diese Daten – von ihrer Speicherung abgesehen – nur mit Ihrer
            Einwilligung oder zur Geltendmachung, Ausübung oder Verteidigung von
            Rechtsansprüchen oder zum Schutz der Rechte einer anderen
            natürlichen oder juristischen Person oder aus Gründen eines
            wichtigen öffentlichen Interesses der Europäischen Union oder eines
            Mitgliedstaats verarbeitet werden.
          </p>
          <p className="policyParagraph"><strong>SSL- bzw. TLS-Verschlüsselung</strong> Diese Seite nutzt aus
            Sicherheitsgründen und zum Schutz der Übertragung vertraulicher
            Inhalte, wie zum Beispiel Bestellungen oder Anfragen, die Sie an uns
            als Seitenbetreiber senden, eine SSL- bzw. TLS-Verschlüsselung.
          </p>
          <p className="policyParagraph">
            Eine verschlüsselte Verbindung erkennen Sie daran, dass die
            Adresszeile des Browsers von „http://“ auf „https://“ wechselt und
            an dem Schloss-Symbol in Ihrer Browserzeile. Wenn die SSL- bzw.
            TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns
            übermitteln, nicht von Dritten mitgelesen werden.
          </p>
          <p className="policyParagraph"><strong>Widerspruch gegen Werbe-E-Mails</strong> Der Nutzung von im Rahmen der
            Impressumspflicht veröffentlichten Kontaktdaten zur Übersendung von
            nicht ausdrücklich angeforderter Werbung und Informationsmaterialien
            wird hiermit widersprochen. Die Betreiber der Seiten behalten sich
            ausdrücklich rechtliche Schritte im Falle der unverlangten Zusendung
            von Werbeinformationen, etwa durch Spam-E-Mails, vor.
          </p>
        </article>

        <article className="policySection">
          <h2>4. Datenerfassung auf dieser Website</h2>
          <p className="policyParagraph"><strong>Cookies</strong> Unsere Internetseiten verwenden so genannte „Cookies“.
            Cookies sind kleine Datenpakete und richten auf Ihrem Endgerät
            keinen Schaden an. Sie werden entweder vorübergehend für die Dauer
            einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies)
            auf Ihrem Endgerät gespeichert.
          </p>
          <p className="policyParagraph">
            Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht.
            Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie
            diese selbst löschen oder eine automatische Löschung durch Ihren
            Webbrowser erfolgt. Cookies können von uns (First-Party-Cookies)
            oder von Drittunternehmen stammen (sog.
          </p>
          <p className="policyParagraph">
            Third-Party-Cookies). Third-Party-Cookies ermöglichen die Einbindung
            bestimmter Dienstleistungen von Drittunternehmen innerhalb von
            Webseiten (z. B.
          </p>
          <p className="policyParagraph">Cookies zur Abwicklung von Zahlungsdienstleistungen). Cookies haben
            verschiedene Funktionen. Zahlreiche Cookies sind technisch
            notwendig, da bestimmte Webseitenfunktionen ohne diese nicht
            funktionieren würden (z.
          </p>
          <p className="policyParagraph">
            B. die Warenkorbfunktion oder die Anzeige von Videos). Andere
            Cookies können zur Auswertung des Nutzerverhaltens oder zu
            Werbezwecken verwendet werden. Cookies, die zur Durchführung des
            elektronischen Kommunikationsvorgangs, zur Bereitstellung
            bestimmter, von Ihnen erwünschter Funktionen (z.
          </p>
          <p className="policyParagraph">
            B. für die Warenkorbfunktion) oder zur Optimierung der Website (z.
            B. Cookies zur Messung des Webpublikums) erforderlich sind
            (notwendige Cookies), werden auf Grundlage von Art. 6 Abs. 1 lit. f
            DSGVO gespeichert, sofern keine andere Rechtsgrundlage angegeben
            wird.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an der
            Speicherung von notwendigen Cookies zur technisch fehlerfreien und
            optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung
            zur Speicherung von Cookies und vergleichbaren
            Wiedererkennungstechnologien abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage dieser Einwilligung (Art.
            6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG); die Einwilligung ist
            jederzeit widerrufbar. Sie können Ihren Browser so einstellen, dass
            Sie über das Setzen von Cookies informiert werden und Cookies nur im
            Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle
            oder generell ausschließen sowie das automatische Löschen der
            Cookies beim Schließen des Browsers aktivieren.
          </p>
          <p className="policyParagraph">
            Bei der Deaktivierung von Cookies kann die Funktionalität dieser
            Website eingeschränkt sein. Welche Cookies und Dienste auf dieser
            Website eingesetzt werden, können Sie dieser Datenschutzerklärung
            entnehmen. Server-Log-Dateien Der Provider der Seiten erhebt und
            speichert automatisch Informationen in so genannten
            Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.
          </p>
          <p className="policyParagraph">
            Dies sind: Browsertyp und Browserversion verwendetes Betriebssystem
            Referrer URL Hostname des zugreifenden Rechners Uhrzeit der
            Serveranfrage IP-Adresse Eine Zusammenführung dieser Daten mit
            anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser
            Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der
            Websitebetreiber hat ein berechtigtes Interesse an der technisch
            fehlerfreien Darstellung und der Optimierung seiner Website – hierzu
            müssen die Server-Log-Files erfasst werden.
          </p>
          <p className="policyParagraph"><strong>Kontaktformular</strong> Wenn Sie uns per Kontaktformular Anfragen zukommen
            lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der
            von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der
            Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
            Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die
            Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1
            lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
            zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
            erforderlich ist.
          </p>
          <p className="policyParagraph">
            In allen übrigen Fällen beruht die Verarbeitung auf unserem
            berechtigten Interesse an der effektiven Bearbeitung der an uns
            gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer
            Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt
            wurde; die Einwilligung ist jederzeit widerrufbar. Die von Ihnen im
            Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns
            zur Löschung auffordern, Ihre Einwilligung zur Speicherung
            widerrufen oder der Zweck für die Datenspeicherung entfällt (z. B.
            nach abgeschlossener Bearbeitung Ihrer Anfrage).
          </p>
          <p className="policyParagraph">
            Zwingende gesetzliche Bestimmungen – insbesondere
            Aufbewahrungsfristen – bleiben unberührt. Anfrage per E-Mail,
            Telefon oder Telefax Wenn Sie uns per E-Mail, Telefon oder Telefax
            kontaktieren, wird Ihre Anfrage inklusive aller daraus
            hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke
            der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
            Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>
          <p className="policyParagraph">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs.
            1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags
            zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen
            erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung
            auf unserem berechtigten Interesse an der effektiven Bearbeitung der
            an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf
            Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) sofern diese
            abgefragt wurde; die Einwilligung ist jederzeit widerrufbar. Die von
            Ihnen an uns per Kontaktanfragen übersandten Daten verbleiben bei
            uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur
            Speicherung widerrufen oder der Zweck für die Datenspeicherung
            entfällt (z.
          </p>
          <p className="policyParagraph">
            B. nach abgeschlossener Bearbeitung Ihres Anliegens). Zwingende
            gesetzliche Bestimmungen – insbesondere gesetzliche
            Aufbewahrungsfristen – bleiben unberührt. Kommentar­funktion auf
            dieser Website Für die Kommentarfunktion auf dieser Seite werden
            neben Ihrem Kommentar auch Angaben zum Zeitpunkt der Erstellung des
            Kommentars und, wenn Sie nicht anonym posten, der von Ihnen gewählte
            Nutzername gespeichert.
          </p>
          <p className="policyParagraph"><strong>Speicherdauer</strong> der Kommentare Die Kommentare und die damit
            verbundenen Daten werden gespeichert und verbleiben auf dieser
            Website, bis der kommentierte Inhalt vollständig gelöscht wurde oder
            die Kommentare aus rechtlichen Gründen gelöscht werden müssen (z. B.
            beleidigende Kommentare). Rechtsgrundlage Die Speicherung der
            Kommentare erfolgt auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1
            lit. a DSGVO).
          </p>
          <p className="policyParagraph">
            Sie können eine von Ihnen erteilte Einwilligung jederzeit
            widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns.
            Die Rechtmäßigkeit der bereits erfolgten Datenverarbeitungsvorgänge
            bleibt vom Widerruf unberührt.
          </p>
          <p className="policyParagraph"><strong>Gravatar</strong> Wir haben Gravatar auf dieser Website eingebunden. Anbieter
            ist die Automattic Inc., 60 29th Street #343, San Francisco, CA
            94110, USA (nachfolgend Gravatar). Gravatar ist ein Tool, das es
            ermöglicht, persönliche Bilder (Avatare) für die Nutzer unserer
            Website bereitzustellen.
          </p>
          <p className="policyParagraph">
            Die Avatare dienen als visuelle Repräsentationen der Nutzer und
            werden überall dort angezeigt, wo ein Nutzer mit der Plattform
            interagiert (z. B. in Foren oder Chats). Wenn ein Nutzer mit der
            Plattform interagiert, wird sein Avatar basierend auf der mit seiner
            E-Mail-Adresse verknüpften Auswahl angezeigt.
          </p>
          <p className="policyParagraph">
            Dies verleiht der Online-Präsenz der Nutzer eine persönliche Note
            und erleichtert die Identifizierung, da das gewählte Bild den
            Nutzern zugeordnet wird, wenn sie online aktiv sind. Wenn Sie auf
            unserer Website kommentieren bzw. interagieren und dabei Gravatar
            aktiviert ist, wird der Hash der E-Mail-Adresse des Nutzers, der
            Gravatar nutzt (wird als ID genutzt) von Gravatar verarbeitet. Die
            Verwendung von Gravatar erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
            f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an einer
            ansprechenden Darstellung seiner Foren. Sofern eine entsprechende
            Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG. Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Weitere Details entnehmen Sie der Datenschutzerklärung des Anbieters
            unter{" "}
            <a
              href="https://automattic.com/privacy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://automattic.com/privacy/
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll.
          </p>
          <p className="policyParagraph">
            Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich,
            diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/4709"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/4709
            </a>
            .
          </p>
        </article>

        <article className="policySection">
          <h2>5. Soziale Medien</h2>
          <p className="policyParagraph"><strong>Social-Media-Elemente mit Shariff</strong> Auf dieser Website werden Elemente
            von sozialen Medien verwendet (z. B. Facebook, X, Instagram,
            Pinterest, XING, LinkedIn, Tumblr).
          </p>
          <p className="policyParagraph">
            Die Social-Media-Elemente können Sie in der Regel anhand der
            jeweiligen Social-Media-Logos erkennen. Um den Datenschutz auf
            dieser Website zu gewährleisten, verwenden wir diese Elemente nur
            zusammen mit der sogenannten „Shariff“-Lösung. Diese Anwendung
            verhindert, dass die auf dieser Website integrierten
            Social-Media-Elemente Ihre personenbezogenen Daten schon beim ersten
            Betreten der Seite an den jeweiligen Anbieter übertragen.
          </p>
          <p className="policyParagraph">
            Erst wenn Sie das jeweilige Social-Media-Element durch Anklicken der
            zugehörigen Schaltfläche aktivieren, wird eine direkte Verbindung
            zum Server des Anbieters hergestellt (Einwilligung). Sobald Sie das
            Social-Media-Element aktivieren, erhält der jeweilige Anbieter die
            Information, dass Sie mit Ihrer IP-Adresse diese Website besucht
            haben. Wenn Sie gleichzeitig in Ihrem jeweiligen
            Social-Media-Account (z.
          </p>
          <p className="policyParagraph">
            B. Facebook) eingeloggt sind, kann der jeweilige Anbieter den Besuch
            dieser Website Ihrem Benutzerkonto zuordnen. Das Aktivieren des
            Plugins stellt eine Einwilligung im Sinne des Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG dar.
          </p>
          <p className="policyParagraph">
            Diese Einwilligung können Sie jederzeit mit Wirkung für die Zukunft
            widerrufen. Der Einsatz des Dienstes erfolgt, um die gesetzlich
            vorgeschriebenen Einwilligungen für den Einsatz bestimmter
            Technologien einzuholen. Rechtsgrundlage hierfür ist Art. 6 Abs. 1
            lit. c DSGVO.
          </p>
          <p className="policyParagraph"><strong>Facebook</strong> Auf dieser Website sind Elemente des sozialen Netzwerks
            Facebook integriert. Anbieter dieses Dienstes ist die Meta Platforms
            Ireland Limited, Merrion Road, Dublin 4, D04 X2K5, Irland. Die
            erfassten Daten werden nach Aussage von Facebook jedoch auch in die
            USA und in andere Drittländer übertragen.
          </p>
          <p className="policyParagraph">
            Eine Übersicht über die Facebook Social-Media-Elemente finden Sie
            hier:{" "}
            <a
              href="https://developers.facebook.com/docs/plugins/?locale=de_DE"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developers.facebook.com/docs/plugins/?locale=de_DE
            </a>
            . Wenn das Social-Media-Element aktiv ist, wird eine direkte
            Verbindung zwischen Ihrem Endgerät und dem Facebook-Server
            hergestellt. Facebook erhält dadurch die Information, dass Sie mit
            Ihrer IP-Adresse diese Website besucht haben.
          </p>
          <p className="policyParagraph">
            Wenn Sie den Facebook „Like-Button“ anklicken, während Sie in Ihrem
            Facebook-Account eingeloggt sind, können Sie die Inhalte dieser
            Website auf Ihrem Facebook-Profil verlinken. Dadurch kann Facebook
            den Besuch dieser Website Ihrem Benutzerkonto zuordnen. Wir weisen
            darauf hin, dass wir als Anbieter der Seiten keine Kenntnis vom
            Inhalt der übermittelten Daten sowie deren Nutzung durch Facebook
            erhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu finden Sie in der Datenschutzerklärung
            von Facebook unter:{" "}
            <a
              href="https://de-de.facebook.com/privacy/explanation"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://de-de.facebook.com/privacy/explanation
            </a>
            . Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer
            Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG.
            Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Soweit mit Hilfe des hier beschriebenen Tools personenbezogene Daten
            auf unserer Website erfasst und an Facebook weitergeleitet werden,
            sind wir und die Meta Platforms Ireland Limited, 4 Grand Canal
            Square, Grand Canal Harbour, Dublin 2, Irland gemeinsam für diese
            Datenverarbeitung verantwortlich (Art. 26 DSGVO). Die gemeinsame
            Verantwortlichkeit beschränkt sich dabei ausschließlich auf die
            Erfassung der Daten und deren Weitergabe an Facebook. Die nach der
            Weiterleitung erfolgende Verarbeitung durch Facebook ist nicht Teil
            der gemeinsamen Verantwortung.
          </p>
          <p className="policyParagraph">
            Die uns gemeinsam obliegenden Verpflichtungen wurden in einer
            Vereinbarung über gemeinsame Verarbeitung festgehalten. Den Wortlaut
            der Vereinbarung finden Sie unter:{" "}
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            . Laut dieser Vereinbarung sind wir für die Erteilung der
            Datenschutzinformationen beim Einsatz des Facebook-Tools und für die
            datenschutzrechtlich sichere Implementierung des Tools auf unserer
            Website verantwortlich.
          </p>
          <p className="policyParagraph">
            Für die Datensicherheit der Facebook-Produkte ist Facebook
            verantwortlich. Betroffenenrechte (z. B.
          </p>
          <p className="policyParagraph">
            Auskunftsersuchen) hinsichtlich der bei Facebook verarbeiteten Daten
            können Sie direkt bei Facebook geltend machen. Wenn Sie die
            Betroffenenrechte bei uns geltend machen, sind wir verpflichtet,
            diese an Facebook weiterzuleiten. Die Datenübertragung in die USA
            wird auf die Standardvertragsklauseln der EU-Kommission gestützt.
          </p>
          <p className="policyParagraph">
            Details finden Sie hier:{" "}
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ,{" "}
            <a
              href="https://de-de.facebook.com/help/566994660333381"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://de-de.facebook.com/help/566994660333381
            </a>{" "}
            und{" "}
            <a
              href="https://www.facebook.com/policy.php"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/policy.php
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll.
          </p>
          <p className="policyParagraph">
            Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich,
            diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/4452"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/4452
            </a>
            . X (ehemals Twitter) Auf dieser Website sind Funktionen des
            Dienstes X (ehemals Twitter) eingebunden.
          </p>
          <p className="policyParagraph">
            Diese Funktionen werden angeboten durch den Mutterkonzern X Corp.,
            1355 Market Street, Suite 900, San Francisco, CA 94103, USA. Für die
            Datenverarbeitung von außerhalb der USA lebenden Personen ist die
            Niederlassung Twitter International Unlimited Company, One
            Cumberland Place, Fenian Street, Dublin 2, D02 AX07, Irland,
            verantwortlich. Wenn das Social-Media-Element aktiv ist, wird eine
            direkte Verbindung zwischen Ihrem Endgerät und dem X-Server
            hergestellt.
          </p>
          <p className="policyParagraph"><strong>X (ehemals Twitter)</strong> erhält dadurch Informationen über den Besuch
            dieser Website durch Sie. Durch das Benutzen von X (ehemals Twitter)
            und der Funktion „Re-Tweet“ bzw. „Repost“ werden die von Ihnen
            besuchten Websites mit Ihrem X (ehemals Twitter)-Account verknüpft
            und anderen Nutzern bekannt gegeben. Wir weisen darauf hin, dass wir
            als Anbieter der Seiten keine Kenntnis vom Inhalt der übermittelten
            Daten sowie deren Nutzung durch X (ehemals Twitter) erhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu finden Sie in der Datenschutzerklärung
            von X (ehemals Twitter) unter:{" "}
            <a
              href="https://x.com/de/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://x.com/de/privacy
            </a>
            . Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer
            Einwilligung nach Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG.
            Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt. Details finden
            Sie hier:{" "}
            <a
              href="https://gdpr.x.com/en/controller-to-controller-transfers.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://gdpr.x.com/en/controller-to-controller-transfers.html
            </a>
            . Ihre Datenschutzeinstellungen bei X (ehemals Twitter) können Sie
            in den Konto-Einstellungen unter{" "}
            <a
              href="https://x.com/settings/account"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://x.com/settings/account
            </a>{" "}
            ändern.
          </p>
          <p className="policyParagraph">
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu erhalten Sie vom Anbieter unter
            folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/2710"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/2710
            </a>
            . Instagram Auf dieser Website sind Funktionen des Dienstes
            Instagram eingebunden. Diese Funktionen werden angeboten durch die
            Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5,
            Irland.
          </p>
          <p className="policyParagraph">
            Wenn das Social-Media-Element aktiv ist, wird eine direkte
            Verbindung zwischen Ihrem Endgerät und dem Instagram-Server
            hergestellt. Instagram erhält dadurch Informationen über den Besuch
            dieser Website durch Sie. Wenn Sie in Ihrem Instagram-Account
            eingeloggt sind, können Sie durch Anklicken des Instagram-Buttons
            die Inhalte dieser Website mit Ihrem Instagram-Profil verlinken.
          </p>
          <p className="policyParagraph">
            Dadurch kann Instagram den Besuch dieser Website Ihrem Benutzerkonto
            zuordnen. Wir weisen darauf hin, dass wir als Anbieter der Seiten
            keine Kenntnis vom Inhalt der übermittelten Daten sowie deren
            Nutzung durch Instagram erhalten. Die Nutzung dieses Dienstes
            erfolgt auf Grundlage Ihrer Einwilligung nach Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Soweit mit Hilfe des
            hier beschriebenen Tools personenbezogene Daten auf unserer Website
            erfasst und an Facebook bzw. Instagram weitergeleitet werden, sind
            wir und die Meta Platforms Ireland Limited, 4 Grand Canal Square,
            Grand Canal Harbour, Dublin 2, Irland gemeinsam für diese
            Datenverarbeitung verantwortlich (Art. 26 DSGVO).
          </p>
          <p className="policyParagraph">
            Die gemeinsame Verantwortlichkeit beschränkt sich dabei
            ausschließlich auf die Erfassung der Daten und deren Weitergabe an
            Facebook bzw. Instagram. Die nach der Weiterleitung erfolgende
            Verarbeitung durch Facebook bzw.
          </p>
          <p className="policyParagraph"><strong>Instagram</strong> ist nicht Teil der gemeinsamen Verantwortung. Die uns
            gemeinsam obliegenden Verpflichtungen wurden in einer Vereinbarung
            über gemeinsame Verarbeitung festgehalten. Den Wortlaut der
            Vereinbarung finden Sie unter:{" "}
            <a
              href="https://www.facebook.com/legal/controller_addendum"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/legal/controller_addendum
            </a>
            .
          </p>
          <p className="policyParagraph">
            Laut dieser Vereinbarung sind wir für die Erteilung der
            Datenschutzinformationen beim Einsatz des Facebook- bzw.
            Instagram-Tools und für die datenschutzrechtlich sichere
            Implementierung des Tools auf unserer Website verantwortlich. Für
            die Datensicherheit der Facebook bzw.
          </p>
          <p className="policyParagraph">
            Instagram-Produkte ist Facebook verantwortlich. Betroffenenrechte
            (z. B.
          </p>
          <p className="policyParagraph">
            Auskunftsersuchen) hinsichtlich der bei Facebook bzw. Instagram
            verarbeiteten Daten können Sie direkt bei Facebook geltend machen.
            Wenn Sie die Betroffenenrechte bei uns geltend machen, sind wir
            verpflichtet, diese an Facebook weiterzuleiten.
          </p>
          <p className="policyParagraph">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt. Details finden
            Sie hier:{" "}
            <a
              href="https://www.facebook.com/legal/EU_data_transfer_addendum"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/legal/EU_data_transfer_addendum
            </a>
            ,{" "}
            <a
              href="https://privacycenter.instagram.com/policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://privacycenter.instagram.com/policy/
            </a>{" "}
            und{" "}
            <a
              href="https://de-de.facebook.com/help/566994660333381"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://de-de.facebook.com/help/566994660333381
            </a>
            . Weitere Informationen hierzu finden Sie in der
            Datenschutzerklärung von Instagram:{" "}
            <a
              href="https://privacycenter.instagram.com/policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://privacycenter.instagram.com/policy/
            </a>
            .
          </p>
          <p className="policyParagraph">
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu erhalten Sie vom Anbieter unter
            folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/4452"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/4452
            </a>
            . Tumblr Diese Website nutzt Schaltflächen und sonstige Elemente des
            Dienstes Tumblr. Anbieter ist die Tumblr, Inc., 35 East 21st St,
            10th Floor, New York, NY 10010, USA.
          </p>
          <p className="policyParagraph">
            Wenn das Social-Media-Element aktiv ist, wird eine direkte
            Verbindung zwischen Ihrem Endgerät und dem Tumblr-Server
            hergestellt. Tumblr erhält dadurch Informationen über den Besuch
            dieser Website durch Sie. Die Tumblr-Schaltflächen ermöglichen es
            Ihnen, einen Beitrag oder eine Seite bei Tumblr zu teilen oder dem
            Anbieter bei Tumblr zu folgen.
          </p>
          <p className="policyParagraph">
            Wenn Sie eine unserer Websites mit Tumblr-Button aufrufen, baut der
            Browser eine direkte Verbindung mit den Servern von Tumblr auf. Wir
            haben keinen Einfluss auf den Umfang der Daten, die Tumblr mit Hilfe
            dieses Plugins erhebt und übermittelt. Nach aktuellem Stand werden
            die IP-Adresse des Nutzers sowie die URL der jeweiligen Website
            übermittelt.
          </p>
          <p className="policyParagraph">
            Die Nutzung dieses Dienstes erfolgt auf Grundlage Ihrer Einwilligung
            nach Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG. Die
            Einwilligung ist jederzeit widerrufbar. Weitere Informationen hierzu
            finden sich in der Datenschutzerklärung von Tumblr unter:{" "}
            <a
              href="https://www.tumblr.com/privacy/de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.tumblr.com/privacy/de
            </a>
            .
          </p>
        </article>

        <article className="policySection">
          <h2>6. Analyse-Tools und Werbung</h2>
          <p className="policyParagraph"><strong>Matomo</strong> Diese Website benutzt den Open Source Webanalysedienst
            Matomo. Mit Hilfe von Matomo sind wir in der Lage Daten über die
            Nutzung unserer Website durch die Websitebesucher zu erfassen und zu
            analysieren. Hierdurch können wir u. a. herausfinden, wann welche
            Seitenaufrufe getätigt wurden und aus welcher Region sie kommen.
          </p>
          <p className="policyParagraph">
            Außerdem erfassen wir verschiedene Logdateien (z. B. IP-Adresse,
            Referrer, verwendete Browser und Betriebssysteme) und können messen,
            ob unsere Websitebesucher bestimmte Aktionen durchführen (z.
          </p>
          <p className="policyParagraph">B. Klicks, Käufe u. Ä.).</p>
          <p className="policyParagraph">
            Die Nutzung dieses Analyse-Tools erfolgt auf Grundlage von Art. 6
            Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
            Interesse an der Analyse des Nutzerverhaltens, um sowohl sein
            Webangebot als auch seine Werbung zu optimieren. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Hosting Wir hosten Matomo ausschließlich auf unseren eigenen
            Servern, sodass alle Analysedaten bei uns verbleiben und nicht
            weitergegeben werden. IONOS WebAnalytics Diese Website nutzt die
            Analysedienste von IONOS WebAnalytics (im Folgenden: IONOS).
            Anbieter ist die 1&amp;1 IONOS SE, Elgendorfer Straße 57, D – 56410
            Montabaur.
          </p>
          <p className="policyParagraph">
            Im Rahmen der Analysen mit IONOS können u. a. Besucherzahlen und
            –verhalten (z. B.
          </p>
          <p className="policyParagraph">
            Anzahl der Seitenaufrufe, Dauer eines Webseitenbesuchs,
            Absprungraten), Besucherquellen (d. h., von welcher Seite der
            Besucher kommt), Besucherstandorte sowie technische Daten (Browser-
            und Betriebssystemversionen) analysiert werden. Zu diesem Zweck
            speichert IONOS insbesondere folgende Daten: Referrer (zuvor
            besuchte Webseite) angeforderte Webseite oder Datei Browsertyp und
            Browserversion verwendetes Betriebssystem verwendeter Gerätetyp
            Uhrzeit des Zugriffs IP-Adresse in anonymisierter Form (wird nur zur
            Feststellung des Orts des Zugriffs verwendet) Die Datenerfassung
            erfolgt laut IONOS vollständig anonymisiert, sodass sie nicht zu
            einzelnen Personen zurückverfolgt werden kann. Cookies werden von
            IONOS WebAnalytics nicht gespeichert.
          </p>
          <p className="policyParagraph">
            Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art.
            6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
            Interesse an der statistischen Analyse des Nutzerverhaltens, um
            sowohl sein Webangebot als auch seine Werbung zu optimieren. Sofern
            eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Weitere Informationen zur Datenerfassung und Verarbeitung durch
            IONOS WebAnalytics entnehmen Sie der Datenschutzerklaerung von IONOS
            unter folgendem Link:{" "}
            <a
              href="https://www.ionos.de/terms-gtc/datenschutzerklaerung/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.ionos.de/terms-gtc/datenschutzerklaerung/
            </a>{" "}
            WP Statistics Diese Website nutzt das Analysetool WP Statistics, um
            Besucherzugriffe statistisch auszuwerten. Anbieter ist Veronalabs,
            Tatari 64, 10134, Tallinn, Estland (
            <a
              href="https://veronalabs.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://veronalabs.com
            </a>
            ). Mit WP Statistics können wir die Nutzung unserer Website
            analysieren.
          </p>
          <p className="policyParagraph"><strong>WP Statistics</strong> erfasst dabei u. a. Logdateien (IP-Adresse, Referrer,
            verwendete Browser, Herkunft des Nutzers, verwendete Suchmaschine)
            und Aktionen, die die Websitebesucher auf der Seite getätigt haben
            (z. B.
          </p>
          <p className="policyParagraph">
            Klicks und Ansichten). Die mit WP Statistics erfassten Daten werden
            ausschließlich auf unserem eigenen Server gespeichert. Die Nutzung
            dieses Analyse-Tools erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
            DSGVO.
          </p>
          <p className="policyParagraph">
            Wir haben ein berechtigtes Interesse an der anonymisierten Analyse
            des Nutzerverhaltens, um sowohl unser Webangebot als auch unsere
            Werbung zu optimieren. Sofern eine entsprechende Einwilligung
            abgefragt wurde, erfolgt die Verarbeitung ausschließlich auf
            Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG,
            soweit die Einwilligung die Speicherung von Cookies oder den Zugriff
            auf Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar.
          </p>
        </article>

        <article className="policySection">
          <h2>7. Newsletter</h2>
          <p className="policyParagraph"><strong>Newsletter­daten</strong> Wenn Sie den auf der Website angebotenen Newsletter
            beziehen möchten, benötigen wir von Ihnen eine E-Mail-Adresse sowie
            Informationen, welche uns die Überprüfung gestatten, dass Sie der
            Inhaber der angegebenen E-Mail-Adresse sind und mit dem Empfang des
            Newsletters einverstanden sind. Weitere Daten werden nicht bzw. nur
            auf freiwilliger Basis erhoben. Diese Daten verwenden wir
            ausschließlich für den Versand der angeforderten Informationen und
            geben diese nicht an Dritte weiter.
          </p>
          <p className="policyParagraph">
            Die Verarbeitung der in das Newsletteranmeldeformular eingegebenen
            Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art.
            6 Abs. 1 lit. a DSGVO). Die erteilte Einwilligung zur Speicherung
            der Daten, der E-Mail-Adresse sowie deren Nutzung zum Versand des
            Newsletters können Sie jederzeit widerrufen, etwa über den
            „Austragen“-Link im Newsletter. Die Rechtmäßigkeit der bereits
            erfolgten Datenverarbeitungsvorgänge bleibt vom Widerruf unberührt.
          </p>
          <p className="policyParagraph">
            Die von Ihnen zum Zwecke des Newsletter-Bezugs bei uns hinterlegten
            Daten werden von uns bis zu Ihrer Austragung aus dem Newsletter bei
            uns bzw. dem Newsletterdiensteanbieter gespeichert und nach der
            Abbestellung des Newsletters oder nach Zweckfortfall aus der
            Newsletterverteilerliste gelöscht. Wir behalten uns vor,
            E-Mail-Adressen aus unserem Newsletterverteiler nach eigenem
            Ermessen im Rahmen unseres berechtigten Interesses nach Art. 6 Abs.
            1 lit. f DSGVO zu löschen oder zu sperren. Daten, die zu anderen
            Zwecken bei uns gespeichert wurden, bleiben hiervon unberührt.
          </p>
          <p className="policyParagraph">
            Nach Ihrer Austragung aus der Newsletterverteilerliste wird Ihre
            E-Mail-Adresse bei uns bzw. dem Newsletterdiensteanbieter ggf. in
            einer Blacklist gespeichert, sofern dies zur Verhinderung künftiger
            Mailings erforderlich ist. Die Daten aus der Blacklist werden nur
            für diesen Zweck verwendet und nicht mit anderen Daten
            zusammengeführt. Dies dient sowohl Ihrem Interesse als auch unserem
            Interesse an der Einhaltung der gesetzlichen Vorgaben beim Versand
            von Newslettern (berechtigtes Interesse im Sinne des Art. 6 Abs. 1
            lit. f DSGVO).
          </p>
          <p className="policyParagraph">
            Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie
            können der Speicherung widersprechen, sofern Ihre Interessen unser
            berechtigtes Interesse überwiegen. Newsletterversand an
            Bestandskunden Wenn Sie Waren oder Dienstleistungen bei uns
            bestellen und hierbei Ihre E-Mail-Adresse hinterlegen, kann diese
            E-Mail-Adresse in der Folge durch uns für den Versand von
            Newslettern verwendet werden, sofern wir Sie vorab hierüber
            informieren.
          </p>
          <p className="policyParagraph">
            In einem solchen Fall wird über den Newsletter nur Direktwerbung für
            eigene ähnliche Waren oder Dienstleistungen versendet. Die Zusendung
            dieses Newsletters kann von Ihnen jederzeit gekündigt werden. Zu
            diesem Zweck findet sich in jedem Newsletter ein entsprechender
            Link.
          </p>
          <p className="policyParagraph"><strong>Rechtsgrundlage</strong> für den Versand des Newsletters ist in diesem Fall
            Art. 6 Abs. 1 lit. f DSGVO in Verbindung mit § 7 Abs. 3 UWG. Nach
            Ihrer Austragung aus der Newsletterverteilerliste wird Ihre
            E-Mail-Adresse bei uns ggf. in einer Blacklist gespeichert, um
            künftige Mailings an Sie zu verhindern. Die Daten aus der Blacklist
            werden nur für diesen Zweck verwendet und nicht mit anderen Daten
            zusammengeführt.
          </p>
          <p className="policyParagraph">
            Dies dient sowohl Ihrem Interesse als auch unserem Interesse an der
            Einhaltung der gesetzlichen Vorgaben beim Versand von Newslettern
            (berechtigtes Interesse im Sinne des Art. 6 Abs. 1 lit. f DSGVO).
            Die Speicherung in der Blacklist ist zeitlich nicht befristet. Sie
            können der Speicherung widersprechen, sofern Ihre Interessen unser
            berechtigtes Interesse überwiegen.
          </p>
        </article>

        <article className="policySection">
          <h2>8. Plugins und Tools</h2>
          <p className="policyParagraph"><strong>YouTube</strong> Diese Website bindet Videos der Website YouTube ein.
            Betreiber der Website ist die Google Ireland Limited („Google“),
            Gordon House, Barrow Street, Dublin 4, Irland. Wenn Sie eine unserer
            Webseiten besuchen, auf denen YouTube eingebunden ist, wird eine
            Verbindung zu den Servern von YouTube hergestellt.
          </p>
          <p className="policyParagraph">
            Dabei wird dem YouTube-Server mitgeteilt, welche unserer Seiten Sie
            besucht haben. Des Weiteren kann YouTube verschiedene Cookies auf
            Ihrem Endgerät speichern oder vergleichbare Technologien zur
            Wiedererkennung verwenden (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting). Auf diese Weise kann YouTube Informationen
            über Besucher dieser Website erhalten. Diese Informationen werden u.
            a. verwendet, um Videostatistiken zu erfassen, die
            Anwenderfreundlichkeit zu verbessern und Betrugsversuchen
            vorzubeugen.
          </p>
          <p className="policyParagraph">
            Des Weiteren werden die erfassten Daten im Google-Werbenetzwerk
            verarbeitet. Wenn Sie in Ihrem YouTube-Account eingeloggt sind,
            ermöglichen Sie YouTube, Ihr Surfverhalten direkt Ihrem persönlichen
            Profil zuzuordnen. Dies können Sie verhindern, indem Sie sich aus
            Ihrem YouTube-Account ausloggen.
          </p>
          <p className="policyParagraph">
            Die Nutzung von YouTube erfolgt im Interesse einer ansprechenden
            Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes
            Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
            Datenschutzerklärung von YouTube unter:{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/privacy?hl=de
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll.
          </p>
          <p className="policyParagraph">
            Jedes nach dem DPF zertifizierte Unternehmen verpflichtet sich,
            diese Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5780"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5780
            </a>
            . Vimeo Diese Website nutzt Plugins des Videoportals Vimeo.
          </p>
          <p className="policyParagraph">
            Anbieter ist die Vimeo Inc., 555 West 18th Street, New York, New
            York 10011, USA. Wenn Sie eine unserer mit einem Vimeo-Video
            ausgestatteten Seiten besuchen, wird eine Verbindung zu den Servern
            von Vimeo hergestellt. Dabei wird dem Vimeo-Server mitgeteilt,
            welche unserer Seiten Sie besucht haben.
          </p>
          <p className="policyParagraph">
            Zudem erlangt Vimeo Ihre IP-Adresse. Dies gilt auch dann, wenn Sie
            nicht bei Vimeo eingeloggt sind oder keinen Account bei Vimeo
            besitzen. Die von Vimeo erfassten Informationen werden an den
            Vimeo-Server in den USA übermittelt.
          </p>
          <p className="policyParagraph">
            Wenn Sie in Ihrem Vimeo-Account eingeloggt sind, ermöglichen Sie
            Vimeo, Ihr Surfverhalten direkt Ihrem persönlichen Profil
            zuzuordnen. Dies können Sie verhindern, indem Sie sich aus Ihrem
            Vimeo-Account ausloggen. Zur Wiedererkennung der Websitebesucher
            verwendet Vimeo Cookies bzw. vergleichbare
            Wiedererkennungstechnologien (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting). Die Nutzung von Vimeo erfolgt im
            Interesse einer ansprechenden Darstellung unserer Online-Angebote.
          </p>
          <p className="policyParagraph">
            Dies stellt ein berechtigtes Interesse im Sinne des Art. 6 Abs. 1
            lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
            Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Die Datenübertragung in die USA wird auf
            die Standardvertragsklauseln der EU-Kommission sowie nach Aussage
            von Vimeo auf „berechtigte Geschäftsinteressen“ gestützt.
          </p>
          <p className="policyParagraph">
            Details finden Sie hier:{" "}
            <a
              href="https://vimeo.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://vimeo.com/privacy
            </a>
            . Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der
            Datenschutzerklärung von Vimeo unter:{" "}
            <a
              href="https://vimeo.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://vimeo.com/privacy
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5711"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5711
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Google Fonts</strong> Diese Seite nutzt zur einheitlichen Darstellung von
            Schriftarten so genannte Google Fonts, die von Google bereitgestellt
            werden. Beim Aufruf einer Seite lädt Ihr Browser die benötigten
            Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
            anzuzeigen. Zu diesem Zweck muss der von Ihnen verwendete Browser
            Verbindung zu den Servern von Google aufnehmen.
          </p>
          <p className="policyParagraph">
            Hierdurch erlangt Google Kenntnis darüber, dass über Ihre IP-Adresse
            diese Website aufgerufen wurde. Die Nutzung von Google Fonts erfolgt
            auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber
            hat ein berechtigtes Interesse an der einheitlichen Darstellung des
            Schriftbildes auf seiner Website.
          </p>
          <p className="policyParagraph">
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Wenn Ihr Browser Google
            Fonts nicht unterstützt, wird eine Standardschrift von Ihrem
            Computer genutzt. Weitere Informationen zu Google Fonts finden Sie
            unter{" "}
            <a
              href="https://developers.google.com/fonts/faq"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developers.google.com/fonts/faq
            </a>{" "}
            und in der Datenschutzerklärung von Google:{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/privacy?hl=de
            </a>
            .
          </p>
          <p className="policyParagraph">
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu erhalten Sie vom Anbieter unter
            folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5780"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5780
            </a>
            . Font Awesome Diese Seite nutzt zur einheitlichen Darstellung von
            Schriftarten und Symbolen Font Awesome. Anbieter ist die Fonticons,
            Inc., 6 Porter Road Apartment 3R, Cambridge, Massachusetts, USA.
          </p>
          <p className="policyParagraph">
            Beim Aufruf einer Seite lädt Ihr Browser die benötigten Fonts in
            ihren Browsercache, um Texte, Schriftarten und Symbole korrekt
            anzuzeigen. Zu diesem Zweck muss der von Ihnen verwendete Browser
            Verbindung zu den Servern von Font Awesome aufnehmen. Hierdurch
            erlangt Font Awesome Kenntnis darüber, dass über Ihre IP-Adresse
            diese Website aufgerufen wurde.
          </p>
          <p className="policyParagraph">
            Die Nutzung von Font Awesome erfolgt auf Grundlage von Art. 6 Abs. 1
            lit. f DSGVO. Wir haben ein berechtigtes Interesse an der
            einheitlichen Darstellung des Schriftbildes auf unserer Website.
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Wenn Ihr Browser Font Awesome nicht unterstützt, wird eine
            Standardschrift von Ihrem Computer genutzt. Weitere Informationen zu
            Font Awesome finden Sie und in der Datenschutzerklärung von Font
            Awesome unter:{" "}
            <a
              href="https://fontawesome.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://fontawesome.com/privacy
            </a>
            . MyFonts Diese Seite nutzt MyFonts.
          </p>
          <p className="policyParagraph">
            Hierbei handelt es sich um Schriftarten, die beim Aufrufen unserer
            Website in Ihren Browser geladen werden, um ein einheitliches
            Schriftbild bei der Webseitendarstellung zu gewährleisten. Anbieter
            ist die Monotype Imaging Holdings Inc., 600 Unicorn Park Drive,
            Woburn, Massachusetts 01801, USA. Um die Einhaltung der
            Lizenzbedingungen und die Anzahl der monatlichen Seitenaufrufe zu
            überprüfen, überträgt MyFonts Ihre IP-Adresse zusammen mit der URL
            unserer Webseite und unseren Vertragsdaten auf seine Server in den
            USA.
          </p>
          <p className="policyParagraph">
            Ihre IP-Adresse wird laut Monotype unmittelbar nach der Übertragung
            anonymisiert, sodass kein Personenbezug mehr hergestellt werden kann
            (Anonymisierung). Details entnehmen Sie der Datenschutzerklärung von
            Monotype unter{" "}
            <a
              href="https://www.monotype.com/de/rechtshinweise/datenschutzrichtlinie/datenschutzrichtlinie-zum-tracking-von-webschriften"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.monotype.com/de/rechtshinweise/datenschutzrichtlinie/datenschutzrichtlinie-zum-tracking-von-webschriften
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/6347"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/6347
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Google Maps</strong> Diese Seite nutzt den Kartendienst Google Maps. Anbieter
            ist die Google Ireland Limited („Google“), Gordon House, Barrow
            Street, Dublin 4, Irland. Mit Hilfe dieses Dienstes können wir
            Kartenmaterial auf unserer Website einbinden.
          </p>
          <p className="policyParagraph">
            Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre
            IP-Adresse zu speichern. Diese Informationen werden in der Regel an
            einen Server von Google in den USA übertragen und dort gespeichert.
            Der Anbieter dieser Seite hat keinen Einfluss auf diese
            Datenübertragung.
          </p>
          <p className="policyParagraph">
            Wenn Google Maps aktiviert ist, kann Google zum Zwecke der
            einheitlichen Darstellung der Schriftarten Google Fonts verwenden.
            Beim Aufruf von Google Maps lädt Ihr Browser die benötigten Web
            Fonts in ihren Browsercache, um Texte und Schriftarten korrekt
            anzuzeigen. Die Nutzung von Google Maps erfolgt im Interesse einer
            ansprechenden Darstellung unserer Online-Angebote und an einer
            leichten Auffindbarkeit der von uns auf der Website angegebenen
            Orte.
          </p>
          <p className="policyParagraph">
            Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1
            lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
            Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Die Datenübertragung in die USA wird auf
            die Standardvertragsklauseln der EU-Kommission gestützt.
          </p>
          <p className="policyParagraph">
            Details finden Sie hier:{" "}
            <a
              href="https://privacy.google.com/businesses/gdprcontrollerterms/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://privacy.google.com/businesses/gdprcontrollerterms/
            </a>{" "}
            und{" "}
            <a
              href="https://privacy.google.com/businesses/gdprcontrollerterms/sccs/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://privacy.google.com/businesses/gdprcontrollerterms/sccs/
            </a>
            . Mehr Informationen zum Umgang mit Nutzerdaten finden Sie in der
            Datenschutzerklärung von Google:{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/privacy?hl=de
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5780"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5780
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Bing Maps</strong> Wir haben Bing Maps auf dieser Website eingebunden.
            Anbieter ist die Microsoft Corporation, One Microsoft Way, Redmond,
            WA 98052-6399, United States (nachfolgend „Bing Maps“). Mit Hilfe
            dieses Dienstes können wir Kartenmaterial auf unserer Website
            einbinden.
          </p>
          <p className="policyParagraph">
            Zur Nutzung der Funktionen von Bing Maps ist es notwendig, Ihre
            IP-Adresse zu speichern. Diese Informationen werden in der Regel an
            einen Server von Microsoft in den USA übertragen und dort
            gespeichert. Der Anbieter dieser Seite hat keinen Einfluss auf diese
            Datenübertragung.
          </p>
          <p className="policyParagraph">
            Die Nutzung von Bing erfolgt im Interesse einer ansprechenden
            Darstellung unserer Online-Angebote und an einer leichten
            Auffindbarkeit der von uns auf der Website angegebenen Orte. Dies
            stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f
            DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt wurde,
            erfolgt die Verarbeitung ausschließlich auf Grundlage von Art. 6
            Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung
            die Speicherung von Cookies oder den Zugriff auf Informationen im
            Endgerät des Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt. Details finden
            Sie hier:{" "}
            <a
              href="https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://learn.microsoft.com/de-de/compliance/regulatory/offering-eu-model-clauses
            </a>
            . Weitere Details entnehmen Sie der Datenschutzerklärung des
            Anbieters unter{" "}
            <a
              href="https://www.microsoft.com/en-us/maps/bing-maps/product"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.microsoft.com/en-us/maps/bing-maps/product
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>OpenStreetMap</strong> Wir nutzen den Kartendienst von OpenStreetMap (OSM).
            Wir binden das Kartenmaterial von OpenStreetMap auf dem Server der
            OpenStreetMap Foundation, St John’s Innovation Centre, Cowley Road,
            Cambridge, CB4 0WS, Großbritannien, ein. Großbritannien gilt als
            datenschutzrechtlich sicherer Drittstaat.
          </p>
          <p className="policyParagraph">
            Das bedeutet, dass Großbritannien ein Datenschutzniveau aufweist,
            das dem Datenschutzniveau in der Europäischen Union entspricht. Bei
            der Nutzung der OpenStreetMap-Karten wird eine Verbindung zu den
            Servern der OpenStreetMap-Foundation hergestellt. Dabei können u. a.
          </p>
          <p className="policyParagraph">
            Ihre IP-Adresse und weitere Informationen über Ihr Verhalten auf
            dieser Website an die OSMF weitergeleitet werden. OpenStreetMap
            speichert hierzu unter Umständen Cookies in Ihrem Browser oder setzt
            vergleichbare Wiedererkennungstechnologien ein. Die Nutzung von
            OpenStreetMap erfolgt im Interesse einer ansprechenden Darstellung
            unserer Online-Angebote und einer leichten Auffindbarkeit der von
            uns auf der Website angegebenen Orte.
          </p>
          <p className="policyParagraph">
            Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1
            lit. f DSGVO dar. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
            Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Google reCAPTCHA Wir nutzen „Google
            reCAPTCHA“ (im Folgenden „reCAPTCHA“) auf dieser Website.
          </p>
          <p className="policyParagraph">
            Anbieter ist die Google Ireland Limited („Google“), Gordon House,
            Barrow Street, Dublin 4, Irland. Mit reCAPTCHA soll überprüft
            werden, ob die Dateneingabe auf dieser Website (z. B. in einem
            Kontaktformular) durch einen Menschen oder durch ein automatisiertes
            Programm erfolgt.
          </p>
          <p className="policyParagraph">
            Hierzu analysiert reCAPTCHA das Verhalten des Websitebesuchers
            anhand verschiedener Merkmale. Diese Analyse beginnt automatisch,
            sobald der Websitebesucher die Website betritt. Zur Analyse wertet
            reCAPTCHA verschiedene Informationen aus (z.
          </p>
          <p className="policyParagraph">
            B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website
            oder vom Nutzer getätigte Mausbewegungen). Die bei der Analyse
            erfassten Daten werden an Google weitergeleitet.
          </p>
          <p className="policyParagraph">
            Die reCAPTCHA-Analysen laufen vollständig im Hintergrund.
            Websitebesucher werden nicht darauf hingewiesen, dass eine Analyse
            stattfindet. Die Speicherung und Analyse der Daten erfolgt auf
            Grundlage von Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse daran, seine
            Webangebote vor missbräuchlicher automatisierter Ausspähung und vor
            SPAM zu schützen. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
            Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Weitere Informationen zu Google reCAPTCHA
            entnehmen Sie den Google-Datenschutzbestimmungen und den Google
            Nutzungsbedingungen unter folgenden Links:{" "}
            <a
              href="https://policies.google.com/privacy?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/privacy?hl=de
            </a>{" "}
            und{" "}
            <a
              href="https://policies.google.com/terms?hl=de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://policies.google.com/terms?hl=de
            </a>
            .
          </p>
          <p className="policyParagraph">
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu erhalten Sie vom Anbieter unter
            folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5780"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5780
            </a>
            . hCaptcha Wir nutzen hCaptcha (im Folgenden „hCaptcha“) auf dieser
            Website. Anbieter ist die Intuition Machines, Inc., 2211 Selig
            Drive, Los Angeles, CA 90026, USA (im Folgenden „IMI“). Mit hCaptcha
            soll überprüft werden, ob die Dateneingabe auf dieser Website (z.
          </p>
          <p className="policyParagraph">
            B. in einem Kontaktformular) durch einen Menschen oder durch ein
            automatisiertes Programm erfolgt. Hierzu analysiert hCaptcha das
            Verhalten des Websitebesuchers anhand verschiedener Merkmale. Diese
            Analyse beginnt automatisch, sobald der Websitebesucher eine Website
            mit aktiviertem hCaptcha betritt.
          </p>
          <p className="policyParagraph">
            Zur Analyse wertet hCaptcha verschiedene Informationen aus (z. B.
            IP-Adresse, Verweildauer des Websitebesuchers auf der Website oder
            vom Nutzer getätigte Mausbewegungen).
          </p>
          <p className="policyParagraph">
            Die bei der Analyse erfassten Daten werden an IMI weitergeleitet.
            Wird hCaptcha im „unsichtbaren Modus“ verwendet, laufen die Analysen
            vollständig im Hintergrund. Websitebesucher werden nicht darauf
            hingewiesen, dass eine Analyse stattfindet.
          </p>
          <p className="policyParagraph">
            Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art.
            6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
            Interesse daran, seine Webangebote vor missbräuchlicher
            automatisierter Ausspähung und vor SPAM zu schützen. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Die Datenverarbeitung wird auf Standardvertragsklauseln gestützt,
            die in den Datenverarbeitungszusatz zu den Allgemeinen
            Geschäftsbedingungen von IMI bzw. den Datenverarbeitungsverträgen
            enthalten sind. Weitere Informationen zu hCaptcha entnehmen Sie den
            Datenschutzbestimmungen und Nutzungsbedingungen unter folgenden
            Links:{" "}
            <a
              href="https://www.hcaptcha.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.hcaptcha.com/privacy
            </a>{" "}
            und{" "}
            <a
              href="https://hcaptcha.com/terms"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://hcaptcha.com/terms
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/6388"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/6388
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Friendly Captcha</strong> Wir nutzen Friendly Captcha (im Folgenden „Friendly
            Captcha“) auf dieser Website. Anbieter ist die Friendly Captcha
            GmbH, Am Anger 3-5, 82237 Woerthsee, Deutschland. Mit Friendly
            Captcha soll überprüft werden, ob die Dateneingabe auf dieser
            Website (z.
          </p>
          <p className="policyParagraph">
            B. in einem Kontaktformular) durch einen Menschen oder durch ein
            automatisiertes Programm erfolgt. Hierzu analysiert Friendly Captcha
            das Verhalten des Websitebesuchers anhand verschiedener Merkmale.
            Zur Analyse wertet Friendly Captcha verschiedene Informationen aus
            (z.
          </p>
          <p className="policyParagraph">
            B. anonymisierte IP-Adresse, Referrer, Besuchszeit etc.). Weitere
            Informationen hierzu finden Sie unter:{" "}
            <a
              href="https://friendlycaptcha.com/legal/privacy-end-users/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://friendlycaptcha.com/legal/privacy-end-users/
            </a>
            . Die Speicherung und Analyse der Daten erfolgt auf Grundlage von
            Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse daran, seine
            Webangebote vor missbräuchlicher automatisierter Ausspähung und vor
            SPAM zu schützen. Sofern eine entsprechende Einwilligung abgefragt
            wurde, erfolgt die Verarbeitung ausschließlich auf Grundlage von
            Art. 6 Abs. 1 lit. a DSGVO und § 25 Abs. 1 TDDDG, soweit die
            Einwilligung die Speicherung von Cookies oder den Zugriff auf
            Informationen im Endgerät des Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Cloudflare Turnstile Wir nutzen
            Cloudflare Turnstile (im Folgenden „Turnstile“) auf dieser Website.
          </p>
          <p className="policyParagraph">
            Anbieter ist die Cloudflare Inc., 101 Townsend St., San Francisco,
            CA 94107, USA (im Folgenden „Cloudflare”). Mit Turnstile soll
            überprüft werden, ob die Dateneingabe auf dieser Website (z. B. in
            einem Kontaktformular) durch einen Menschen oder durch ein
            automatisiertes Programm erfolgt.
          </p>
          <p className="policyParagraph">
            Hierzu analysiert Turnstile das Verhalten des Websitebesuchers
            anhand verschiedener Merkmale. Diese Analyse beginnt automatisch,
            sobald der Websitebesucher eine Website mit aktiviertem Turnstile
            betritt. Zur Analyse wertet Turnstile verschiedene Informationen aus
            (z.
          </p>
          <p className="policyParagraph">
            B. IP-Adresse, Verweildauer des Websitebesuchers auf der Website
            oder vom Nutzer getätigte Mausbewegungen). Die bei der Analyse
            erfassten Daten werden an Cloudflare weitergeleitet.
          </p>
          <p className="policyParagraph">
            Die Speicherung und Analyse der Daten erfolgt auf Grundlage von Art.
            6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes
            Interesse daran, seine Webangebote vor missbräuchlicher
            automatisierter Ausspähung und vor SPAM zu schützen. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO und § 25
            Abs. 1 TDDDG, soweit die Einwilligung die Speicherung von Cookies
            oder den Zugriff auf Informationen im Endgerät des Nutzers (z.
          </p>
          <p className="policyParagraph">
            B. Device-Fingerprinting) im Sinne des TDDDG umfasst. Die
            Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Die Datenverarbeitung wird auf Standardvertragsklauseln gestützt,
            die sie hier finden:{" "}
            <a
              href="https://www.cloudflare.com/cloudflare-customer-scc/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.cloudflare.com/cloudflare-customer-scc/
            </a>
            . Weitere Informationen zu Cloudflare Turnstile entnehmen Sie den
            Datenschutzbestimmungen unter{" "}
            <a
              href="https://www.cloudflare.com/cloudflare-customer-dpa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.cloudflare.com/cloudflare-customer-dpa/
            </a>
            . Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5666"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5666
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Wordfence</strong> Wir haben Wordfence auf dieser Website eingebunden.
            Anbieter ist Defiant Inc., Defiant, Inc., 800 5th Ave Ste 4100,
            Seattle, WA 98104, USA (nachfolgend „Wordfence“). Wordfence dient
            dem Schutz unserer Website vor unerwünschten Zugriffen oder
            bösartigen Cyberattacken.
          </p>
          <p className="policyParagraph">
            Zu diesem Zweck stellt unsere Website eine dauerhafte Verbindung zu
            den Servern von Wordfence her, damit Wordfence seine Datenbanken mit
            den auf unserer Website getätigten Zugriffen abgleichen und ggf.
            blockieren kann. Die Verwendung von Wordfence erfolgt auf Grundlage
            von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
            berechtigtes Interesse an einem möglichst effektiven Schutz seiner
            Website vor Cyberattacken.
          </p>
          <p className="policyParagraph">
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Die Datenübertragung in
            die USA wird auf die Standardvertragsklauseln der EU-Kommission
            gestützt. Details finden Sie hier:{" "}
            <a
              href="https://www.wordfence.com/help/general-data-protection-regulation/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.wordfence.com/help/general-data-protection-regulation/
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>CleanTalk</strong> Diese Website nutzt Anti-Spam Plugins von CleanTalk.
            Anbieter ist die CleanTalk Inc, 711 S Carson Street, suite 4, Carson
            City, NV, 89701, USA (nachfolgend „CleanTalk”). CleanTalk dient dem
            Schutz unserer Website von Spam-Aktivitäten (z.
          </p>
          <p className="policyParagraph">
            B. Verhindern von unerwünschter Werbung, unerwünschten Nachrichten
            oder Kommentaren). Zu diesem Zweck erfasst CleanTalk verschiedene
            personenbezogene Daten wie IP-Adresse, E-Mail-Adresse, Nickname des
            Nachrichtensenders, Informationen über die Technologie von
            JavaScript im Browser des Senders und die eingegebenen Texte.
          </p>
          <p className="policyParagraph">
            Diese Informationen werden in der Regel an einen Server von
            CleanTalk in den USA übertragen und dort gespeichert. Aus
            Sicherheitsgründen und als Schutz vor Spam werden Ihre Daten im
            CleanTalk Cloud Service verarbeitet und in Logfiles für maximal 31
            Tage gespeichert. Nach Ablauf der genannten Frist werden diese Daten
            vollständig gelöscht.
          </p>
          <p className="policyParagraph">
            Die Verwendung von CleanTalk erfolgt auf Grundlage von Art. 6 Abs. 1
            lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an
            einem möglichst effektiven Schutz seiner Website Spam-Aktivitäten.
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers im Sinne des TDDDG umfasst.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Die Datenübertragung in
            die USA wird auf die Standardvertragsklauseln der EU-Kommission
            gestützt. Details finden Sie hier:
            <a
              href="https://cleantalk.org/publicoffer#privacy"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://cleantalk.org/publicoffer#privacy
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Akismet</strong> Wir haben Akismet auf dieser Website eingebunden. Anbieter
            ist die Aut O’Mattic A8C Ireland Ltd., Business Centre, No.1 Lower
            Mayor Street, International Financial Services Centre, Dublin 1,
            Irland (nachfolgend Aut O’Mattic), deren Mutterunternehmen in den
            USA sitzt. Akismet ermöglicht es uns, eingestellte Kommentare auf
            ihre Eigenschaft als SPAM hin zu analysieren.
          </p>
          <p className="policyParagraph">
            Zu diesem Zweck verarbeiten wir den angegebenen Besuchernamen, die
            Mailadresse, die IP-Adresse, den Kommentartext, Browsertyp und die
            Zugriffszeit. Die Verwendung von Akismet erfolgt auf Grundlage von
            Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein
            berechtigtes Interesse an einer ungestörten, spamfreien
            Kommunikation mit Websitebesuchern.
          </p>
          <p className="policyParagraph">
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z. B. für Device-Fingerprinting) im Sinne des TDDDG
            umfasst. Die Einwilligung ist jederzeit widerrufbar.
          </p>
          <p className="policyParagraph">
            Weitere Details finden Sie hier:{" "}
            <a
              href="https://akismet.com/gdpr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://akismet.com/gdpr/
            </a>
            . Die Datenübertragung in die USA wird auf die
            Standardvertragsklauseln der EU-Kommission gestützt. Details finden
            Sie hier:{" "}
            <a
              href="https://wordpress.com/support/data-processing-agreements/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://wordpress.com/support/data-processing-agreements/
            </a>
            .
          </p>
          <p className="policyParagraph">
            Das Unternehmen verfügt über eine Zertifizierung nach dem „EU-US
            Data Privacy Framework“ (DPF). Der DPF ist ein Übereinkommen
            zwischen der Europäischen Union und den USA, der die Einhaltung
            europäischer Datenschutzstandards bei Datenverarbeitungen in den USA
            gewährleisten soll. Jedes nach dem DPF zertifizierte Unternehmen
            verpflichtet sich, diese Datenschutzstandards einzuhalten.
          </p>
          <p className="policyParagraph">
            Weitere Informationen hierzu erhalten Sie vom Anbieter unter
            folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/4709"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/4709
            </a>
            . SolidWP Wir haben SolidWP auf dieser Website eingebunden. Anbieter
            ist die iThemes Media LLC, 1720 South Kelly Avenue Edmond, OK 73013,
            USA (nachfolgend „SolidWP“).
          </p>
          <p className="policyParagraph"><strong>SolidWP</strong> dient dem Schutz unserer Website vor unerwünschten Zugriffen
            oder bösartigen Cyberattacken. Zu diesem Zweck erfasst SolidWP u. a.
            Ihre IP-Adresse, Zeitpunkt und Quelle von Login-Versuchen und
            Log-Daten (z.
          </p>
          <p className="policyParagraph">
            B. den verwendeten Browser). SolidWP wird lokal auf unseren Servern
            installiert. Die Verwendung von SolidWP erfolgt auf Grundlage von
            Art. 6 Abs. 1 lit. f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an einem
            möglichst effektiven Schutz seiner Website vor Cyberattacken. Sofern
            eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z. B.
          </p>
          <p className="policyParagraph">
            Device-Fingerprinting) im Sinne des TDDDG umfasst. Die Einwilligung
            ist jederzeit widerrufbar. Ninja Firewall Wir haben Ninja Firewall
            auf dieser Website eingebunden.
          </p>
          <p className="policyParagraph">
            Anbieter ist die NinTechNet Limited, Unit 1603, 16th Floor, The L.
            Plaza 367 – 375 Queen‘s Road Central Sheung Wan, Hong Kong
            (nachfolgend Ninja Firewall). Ninja Firewall dient dem Schutz
            unserer Website vor unerwünschten Zugriffen oder bösartigen
            Cyberattacken.
          </p>
          <p className="policyParagraph">
            Zu diesem Zweck erfasst Ninja Firewall IP-Adresse, Request, Referrer
            und Zeitpunkt des Seitenzugriffs. Ninja Firewall ist auf unseren
            eigenen Servern eingebunden und übermittelt keine personenbezogenen
            Daten an den Anbieter des Tools oder sonstige Dritte. Die Verwendung
            von Ninja Firewall erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f
            DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an einem
            möglichst effektiven Schutz seiner Website vor Cyberattacken.
            Spotify Auf dieser Website sind Funktionen des Musik-Dienstes
            Spotify eingebunden. Anbieter ist die Spotify AB, Birger Jarlsgatan
            61, 113 56 Stockholm in Schweden.
          </p>
          <p className="policyParagraph">
            Die Spotify Plugins erkennen Sie an dem grünen Logo auf dieser
            Website. Eine Übersicht über die Spotify-Plugins finden Sie unter:{" "}
            <a
              href="https://developer.spotify.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://developer.spotify.com
            </a>
            . Dadurch kann beim Besuch dieser Website über das Plugin eine
            direkte Verbindung zwischen Ihrem Browser und dem Spotify-Server
            hergestellt werden.
          </p>
          <p className="policyParagraph"><strong>Spotify</strong> erhält dadurch die Information, dass Sie mit Ihrer
            IP-Adresse diese Website besucht haben. Wenn Sie den Spotify Button
            anklicken, während Sie in Ihrem Spotify-Account eingeloggt sind,
            können Sie die Inhalte dieser Website auf Ihrem Spotify Profil
            verlinken. Dadurch kann Spotify den Besuch dieser Website Ihrem
            Benutzerkonto zuordnen.
          </p>
          <p className="policyParagraph">
            Wir weisen darauf hin, dass bei der Nutzung von Spotify Cookies von
            Google Analytics eingesetzt werden, sodass Ihre Nutzungsdaten bei
            der Nutzung von Spotify auch an Google weitergegeben werden können.
            Google Analytics ist ein Tool des Google-Konzerns zur Analyse des
            Nutzerverhaltens mit Sitz in den USA. Für diese Einbindung ist
            allein Spotify verantwortlich.
          </p>
          <p className="policyParagraph">
            Wir als Websitebetreiber haben auf diese Verarbeitung keinen
            Einfluss. Die Speicherung und Analyse der Daten erfolgt auf
            Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat
            ein berechtigtes Interesse an der ansprechenden akustischen
            Ausgestaltung seiner Website.
          </p>
          <p className="policyParagraph">
            Sofern eine entsprechende Einwilligung abgefragt wurde, erfolgt die
            Verarbeitung ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a
            DSGVO und § 25 Abs. 1 TDDDG, soweit die Einwilligung die Speicherung
            von Cookies oder den Zugriff auf Informationen im Endgerät des
            Nutzers (z. B. Device-Fingerprinting) im Sinne des TDDDG umfasst.
          </p>
          <p className="policyParagraph">
            Die Einwilligung ist jederzeit widerrufbar. Weitere Informationen
            hierzu finden Sie in der Datenschutzerklärung von Spotify:{" "}
            <a
              href="https://www.spotify.com/de/legal/privacy-policy/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.spotify.com/de/legal/privacy-policy/
            </a>
            . Wenn Sie nicht wünschen, dass Spotify den Besuch dieser Website
            Ihrem Spotify-Nutzerkonto zuordnen kann, loggen Sie sich bitte aus
            Ihrem Spotify-Benutzerkonto aus.
          </p>
        </article>

        <article className="policySection">
          <h2>9. Eigene Dienste</h2>
          <p className="policyParagraph"><strong>OneDrive</strong> Wir haben OneDrive auf dieser Website eingebunden. Anbieter
            ist die Microsoft Ireland Operations Limited, One Microsoft Place,
            South County Business Park, Leopardstown, Dublin 18, Irland (im
            folgenden „OneDrive“). OneDrive ermöglicht es uns, einen
            Uploadbereich auf unserer Website einzubinden, in dem Sie Inhalte
            hochladen können.
          </p>
          <p className="policyParagraph">
            Wenn Sie Inhalte hochladen, werden diese auf den Servern von
            OneDrive gespeichert. Wenn Sie unsere Website betreten, wird
            außerdem eine Verbindung zu OneDrive aufgebaut, sodass OneDrive
            feststellen kann, dass Sie unsere Website besucht haben. Die
            Verwendung von OneDrive erfolgt auf Grundlage von Art. 6 Abs. 1 lit.
            f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an einem
            zuverlässigen Uploadbereich auf seiner Website. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die
            Einwilligung ist jederzeit widerrufbar. Das Unternehmen verfügt über
            eine Zertifizierung nach dem „EU-US Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/6474"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/6474
            </a>
            .
          </p>
          <p className="policyParagraph"><strong>Google Drive</strong> Wir haben Google Drive auf dieser Website eingebunden.
            Anbieter ist die Google Ireland Limited („Google“), Gordon House,
            Barrow Street, Dublin 4, Irland. Google Drive ermöglicht es uns,
            einen Uploadbereich auf unserer Website einzubinden, in dem Sie
            Inhalte hochladen können.
          </p>
          <p className="policyParagraph">
            Wenn Sie Inhalte hochladen, werden diese auf den Servern von Google
            Drive gespeichert. Wenn Sie unsere Website betreten, wird außerdem
            eine Verbindung zu Google Drive aufgebaut, sodass Google Drive
            feststellen kann, dass Sie unsere Website besucht haben. Die
            Verwendung von Google Drive erfolgt auf Grundlage von Art. 6 Abs. 1
            lit. f DSGVO.
          </p>
          <p className="policyParagraph">
            Der Websitebetreiber hat ein berechtigtes Interesse an einem
            zuverlässigen Uploadbereich auf seiner Website. Sofern eine
            entsprechende Einwilligung abgefragt wurde, erfolgt die Verarbeitung
            ausschließlich auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO; die
            Einwilligung ist jederzeit widerrufbar. Das Unternehmen verfügt über
            eine Zertifizierung nach dem „EU-US Data Privacy Framework“ (DPF).
          </p>
          <p className="policyParagraph">
            Der DPF ist ein Übereinkommen zwischen der Europäischen Union und
            den USA, der die Einhaltung europäischer Datenschutzstandards bei
            Datenverarbeitungen in den USA gewährleisten soll. Jedes nach dem
            DPF zertifizierte Unternehmen verpflichtet sich, diese
            Datenschutzstandards einzuhalten. Weitere Informationen hierzu
            erhalten Sie vom Anbieter unter folgendem Link:{" "}
            <a
              href="https://www.dataprivacyframework.gov/participant/5780"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.dataprivacyframework.gov/participant/5780
            </a>
            .
          </p>
          <p className="policyParagraph">
            Quelle:{" "}
            <a
              href="https://www.e-recht24.de"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.e-recht24.de
            </a>
          </p>
        </article>
      </div>
    </div>
  );
}

export default DatenSchutz;
